import AccidentTravail from '@/generated/classes/AccidentTravail';
export default class AccidentTravailExtend extends AccidentTravail {
  constructor() {
    super();
  }
}
